module.exports = __webpack_public_path__ + "static/media/screen 5 FN.155bb50e.png";